<div class="layout-main">
    <!-- Skip to content link for accessibility -->
    <a href="#dashboard-content" class="skip-to-content">{{ 'supervisor.skipToContent' | translate }}</a>

    <div class="dashboard-card-container axede-hardware-accelerated">
      <div class="dashboard-card-options" role="tablist" [attr.aria-label]="'supervisor.tabsAria' | translate">
        <div *ngFor="let option of options; let i = index"
             class="dashboard-title-option font-menu"
             [class.active]="selectedOption === option"
             (click)="selectOption(option)"
             role="tab"
             [attr.tabindex]="selectedOption === option ? 0 : -1"
             [attr.aria-selected]="selectedOption === option"
             [attr.aria-controls]="'tab-content-' + i"
             [id]="'tab-' + i">
          {{ (option === 'Campañas' ? 'supervisor.tabs.campaigns' : 'supervisor.tabs.agents') | translate }}
        </div>
      </div>

      <div class="dashboard-content" id="dashboard-content" role="tabpanel">
        <app-campaign-supervisor *ngIf="selectedOption === 'Campañas'"/>
        <app-agents-supervisor *ngIf="selectedOption === 'Agentes'"/>

      </div>
    </div>
  </div>
